import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { usePartner } from '../contexts/PartnerContext';

const Hero: React.FC = () => {
  const { showPartnerModalConfirmation } = usePartner();

  const handleSteamAuth = () => {
    showPartnerModalConfirmation();
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-tesla-black pt-16">
      {/* Минималистичные фоновые элементы */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-gradient-to-r from-purple-500/20 to-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-48 h-48 bg-gradient-to-l from-purple-500/15 to-blue-500/15 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <motion.h1 
            className="text-5xl md:text-6xl font-bold mb-6 tracking-tight"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="text-white">Партнерская программа</span>
            <br />
            <span className="text-purple-400 text-4xl md:text-5xl">CSFADE</span>
          </motion.h1>
          
          <motion.p 
            className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto font-normal leading-relaxed"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Зарабатывайте на партнерской программе CS2 кейсов
          </motion.p>

          <motion.div
            className="flex justify-center mb-16"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <motion.button
              onClick={handleSteamAuth}
              className="bg-purple-600 hover:bg-purple-700 text-white font-medium px-8 py-3 rounded-lg flex items-center space-x-2 transition-all duration-200 hover:scale-105"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span>Войти</span>
              <ArrowRight size={18} />
            </motion.button>
          </motion.div>
        </motion.div>

        {/* Компактная статистика */}
        <motion.div
          className="grid grid-cols-3 gap-6 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {[
            { value: "20%", label: "Комиссия" },
            { value: "∞", label: "Промокоды" },
            { value: "24/7", label: "Статистика" }
          ].map((stat, index) => (
            <motion.div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 text-center hover:bg-white/10 transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
              whileHover={{ y: -2 }}
            >
              <h3 className="text-2xl font-bold text-white mb-1">{stat.value}</h3>
              <p className="text-gray-400 text-xs uppercase tracking-wider font-medium">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Минималистичный индикатор прокрутки */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-px h-12 bg-gradient-to-b from-purple-400/60 to-transparent"
        />
      </motion.div>
    </section>
  );
};

export default Hero; 